export default __webpack_public_path__ + "static/media/Atti.0aeb6eb3.jpeg";